import { IActionsStyle } from '../models/index.js';
export const actionsStyle: IActionsStyle = {
	children: {
		wrapper: {
			display: 'flex',
		},
	},
};
